import LinkedInConversationsPage from "../features/crm/LinkedInConversationsPage";

export default function CrmLinkedInConversationsRoute() {
  return <LinkedInConversationsPage />;
}
